import AutoAwesomeOutlined from "@mui/icons-material/AutoAwesomeOutlined";

import { makeSvgIcon } from "./svg-icon";

export const CandidatesIcon = makeSvgIcon(
  AutoAwesomeOutlined,
  (theme) => theme.palette.candidate.main,
);

export default CandidatesIcon;
